<div class="adaptive-grow-1">
    <div class="fluent-container">
        <nav *ngIf="showSearch && userSession">
            <form [formGroup]="searchForm">
                <div class="column-md-3 column-lg-3 column-sm-6" style="margin-left: auto;">
                    <mat-form-field appearance="fill" style="border-radius: 20px;">
                        <mat-icon matPrefix>search</mat-icon>
                        <input
                            matInput
                            placeholder="Buscar..."
                            formControlName="search"
                        />
                    </mat-form-field>
                </div>
            </form>
        </nav>
    </div>
</div>
